export const testimonials = [
  {
    name: "阿栗不吃瓜皮",
    role: "追剧党 · 3 年老瓜农",
    quote:
      "最喜欢它的时间线排版。以前一个瓜要翻半天帖子才知道前因后果，现在一页看完，还能知道中间是哪一步变了风向。",
    avatar:
      "https://readdy.ai/api/search-image?query=warm%20minimalist%20portrait%20avatar%20of%20a%20young%20woman%20with%20soft%20amber%20studio%20background%2C%20friendly%20neutral%20expression%2C%20editorial%20photography%2C%20no%20text&width=240&height=240&seq=gua-ava-01&orientation=squarish",
  },
  {
    name: "深夜补课选手",
    role: "通勤路上补瓜 · 新入坑",
    quote:
      "我是那种永远慢半拍的人。这里的盘点写得很有条理，分点说清楚了谁在什么时候做了什么，看完终于能跟同事聊上话了。",
    avatar:
      "https://readdy.ai/api/search-image?query=warm%20minimalist%20portrait%20avatar%20of%20a%20young%20man%20with%20soft%20crimson%20studio%20background%2C%20calm%20neutral%20expression%2C%20editorial%20photography%2C%20no%20text&width=240&height=240&seq=gua-ava-02&orientation=squarish",
  },
  {
    name: "皮皮虾观察员",
    role: "综艺区活跃用户",
    quote:
      "分类筛选是真的好用。我不追剧，只想看综艺和音乐现场，点一下就把其他内容过滤掉了，不会被无关的瓜刷屏。",
    avatar:
      "https://readdy.ai/api/search-image?query=warm%20minimalist%20portrait%20avatar%20of%20a%20woman%20with%20short%20hair%20on%20soft%20cream%20studio%20background%2C%20warm%20smile%2C%20editorial%20photography%2C%20no%20text&width=240&height=240&seq=gua-ava-03&orientation=squarish",
  },
];